<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <b-modal ref="modal" :title="title" no-close-on-backdrop @ok="ok($event)" @cancel="close()" @close="close()">
        <div class="edit-plot-content">
            <div class="edit-plot-line">
                <div class="edit-plot-label">名称：</div>
                <div class="edit-plot-input"><input class="form-control" v-model="plot.name"/></div>
            </div>
            <div class="edit-plot-line">
                <div class="edit-plot-label">类型：</div>
                <div class="edit-plot-input">
                    <select class="form-control" v-model="plot.type">
                        <option v-for="type in plotTypes" :key="type.id" :value="type.type">{{type.type}}</option>
                    </select>
                </div>
            </div>
        </div>
        <template v-slot:modal-footer="{ ok, cancel }">
            <div class="w-100 d-flex align-items-center justify-content-between m-0">
                <div>
                    <b-button v-if="isEdit" class="m-1" variant="danger" @click="remove()">删除标绘</b-button>
                </div>
                <div>
                    <b-button v-if="isEdit" class="m-1" variant="warning" @click="redraw()">重画标绘</b-button>
                </div>
                <div class="form-inline">
                    <b-button class="m-1" variant="outline-primary" @click="cancel()">取消</b-button>
                    <b-button class="m-1" variant="primary" @click="ok()">确定</b-button>
                </div>
            </div>
        </template>
    </b-modal>
</template>
<script>
    import * as MsgBox from "../utils/msgBox";
    import User from "../services/user";
    import Plot from "../services/plot";
    import {plotTypes} from "../olMap/featureUtils";

    const defaultPlot = {
        name: "",
        type: "辖区",
    };

    export default {
        name: "EditRectPlotDialog",
        data() {
            return {
                plot: defaultPlot,
                plotTypes: [],
            };
        },
        computed: {
            isEdit() {
                return this.plot && this.plot.id;
            },
            isAdmin() {
                return User.user && User.user.admin;
            },
            title() {
                return (this.isEdit ? "编辑" : "新建") + "矩形标绘";
            },
        },
        methods: {
            modal(plot) {
                this.plotTypes = plotTypes.filter(
                    x => x.category === "rect" && (this.isAdmin ? x.adminEditable : x.userEditable)
                );
                this.plot = plot ? {
                    id: plot.id || 0,
                    name: plot.name || null,
                    type: plot.type || "辖区",
                    minLon: plot.minLon,
                    minLat: plot.minLat,
                    maxLon: plot.maxLon,
                    maxLat: plot.maxLat,
                    rowVersion: plot.rowVersion,
                } : Object.assign({}, defaultPlot);
                return new Promise(resolve => {
                    this.resolve = resolve;
                    this.$refs.modal.show();
                });
            },
            close() {
                this.resolve && this.resolve();
            },
            async ok(e) {
                e.preventDefault();
                if (!(this.plot.name && this.plot.name.trim())) {
                    return await MsgBox.alert(this, "名称不能为空！");
                }
                let plot = {
                    id: this.plot.id || 0,
                    name: this.plot.name,
                    type: this.plot.type,
                    minLon: this.plot.minLon,
                    minLat: this.plot.minLat,
                    maxLon: this.plot.maxLon,
                    maxLat: this.plot.maxLat,
                    rowVersion: this.plot.rowVersion,
                };
                let newId = await Plot.saveRectPlot(plot);
                if (!plot.id) {
                    plot.id = newId;
                }
                this.onResult(plot);
            },
            async remove() {
                if (await MsgBox.confirm(this, `确认要删除矩形标绘“${this.plot.name}”？`)) {
                    await Plot.removeRectPlot(this.plot.id, this.plot.rowVersion);
                    this.onResult(null);
                }
            },
            redraw() {
                this.onResult("redraw");
            },
            onResult(plot) {
                this.resolve && this.resolve(plot);
                this.$refs.modal.hide();
            },
        },
    }
</script>

<style scoped>
    .edit-plot-content > * + *,
    .edit-plot-aliases > * + * {
        margin-top: 0.5rem;
    }

    .edit-plot-line {
        display: flex;
        align-items: stretch;
    }

    .edit-plot-label {
        text-align: right;
        min-width: 100px;
        margin-right: 0.5rem;
        line-height: calc(1.5em + 0.75rem + 2px);
    }

    .edit-plot-input {
        flex: 1;
    }
</style>
